export const LTI_REDIRECT = 'LTI_REDIRECT'

// https://www.figma.com/file/B1Ikh8vmwZAhLHUgHa7tXz/%E2%8C%98-Student-Portal-%2F-Prototypes?node-id=3457%3A63302
export const TILE_COLORS = ['#A3A3A3', '#FFC699', '#CCECCC', '#99E2EA', '#ED9999', '#99B6E8', '#FFE299']
